import Prismic from 'prismic-javascript'
import { createClient as baseCreateClient } from '@prismicio/client'
import { enableAutoPreviews, CreateClientConfig } from '@prismicio/next'

export const apiEndpoint = 'https://matarstraeti.cdn.prismic.io/api/v2'
export const accessToken = ''

const createClientOptions = (req = null, prismicAccessToken = null) => {
	const reqOption = req ? { req } : {}
	const accessTokenOption = prismicAccessToken ? { accessToken: prismicAccessToken } : {}
	return {
		...reqOption,
		...accessTokenOption,
	}
}

// @ts-ignore
export const Client = (req = null) => Prismic.client(apiEndpoint, createClientOptions(req, accessToken))

export function createClient({ previewData, req, ...config }: CreateClientConfig = {}) {
	const client = baseCreateClient(apiEndpoint, config)
	enableAutoPreviews({ client, previewData, req })
	return client
}
